import { Component, Input } from '@angular/core';
import { NumberUtils } from '@libs/index';

@Component({
  selector: 'app-rating-star-icon',
  templateUrl: './rating-star-icon.component.html',
  styleUrls: ['./rating-star-icon.component.scss'],
})
export class RatingStarIconComponent {
  public iconList: string[] = [];

  private _rating: number;
  @Input() set rating(value: number) {
    this.iconList = [];

    if (!NumberUtils.isNumber(value)) {
      return;
    }

    let counter = Math.min(value, 5);
    this._rating = counter;

    while (counter > 0) {
      if (counter >= 1) {
        this.iconList.push('star');
      } else {
        this.iconList.push('star_half');
      }

      counter -= 1;
    }

    const nrExtraEmptyStar = 5 - Math.ceil(this.rating);

    for (let i = 0; i < nrExtraEmptyStar; i += 1) {
      this.iconList.push('star_outline');
    }
  }

  get rating(): number {
    return this._rating;
  }

  @Input() totalReview: number;
}
